import 'css-chunksrc/client/scenes/milestone/details/nameForm/styles.scss';export default {
  "input": "_input_9b0al_1"
};